import React, { ReactElement } from 'react';

export type TableDefinition<R> = {};

export type ColumnDefinition<R> = {
    id?: string;
    label: string | ReactElement;
    render?: (record: R) => ReactElement;
    className?: string;
    props?: (record: R) => object;
};

export const ColumnDefinitions = {
    simple<R>(key: keyof R, label: string | ReactElement, options = {}): ColumnDefinition<R> {
        return {
            label,
            render(record: R) {
                return <div>{record[key]}</div>;
            },
            ...options,
        };
    },
    custom<R>(label: string | ReactElement, render: (record: R) => ReactElement, options = {}) {
        return {
            label,
            render,
            ...options,
        };
    },
};

export const RowClassNames = {
    dangerWhen<R>(errorFunc: (record: R) => boolean) {
        return (record) => {
            return errorFunc(record) ? ['table-row--danger'] : [];
        };
    },
    grayOutWhen<R>(errorFunc: (record: R) => boolean) {
        return (record) => {
            return errorFunc(record) ? ['table-row--grayout'] : [];
        };
    },
    stripe<R>(indexFunc?: (record: R) => number) {
        return (record, index) => {
            const i = indexFunc ? indexFunc(record) : index;
            return i % 2 === 0 ? ['table-row--bg-blue'] : [];
        };
    },
    compose(...classNameFuncs) {
        return (record, index) => {
            return classNameFuncs.map((f) => f(record, index)).reduce((arr, item) => arr.concat([item]), []);
        };
    },
};
